/**
 * Gallery visibility levels (DB values unchanged).
 */
export const GALLERY_PUBLICITY_LABELS = {
  public: 'Public',
  private_view: 'Team View',
  private_edit: 'Managed',
  private_access: 'Team Access',
};

export const GALLERY_PUBLICITY_DESCRIPTIONS = {
  public: 'Public site + gallery list. Managers edit/delete.',
  private_view: 'Logged-in members only. Managers edit/delete.',
  private_edit: 'Managers only (view, edit, delete).',
  private_access: 'Members add photos. Managers edit/delete.',
};

/** Label + description for gallery form visibility cards */
export const GALLERY_PUBLICITY_FORM_OPTIONS = [
  { value: 'public', label: GALLERY_PUBLICITY_LABELS.public, description: GALLERY_PUBLICITY_DESCRIPTIONS.public },
  { value: 'private_view', label: GALLERY_PUBLICITY_LABELS.private_view, description: GALLERY_PUBLICITY_DESCRIPTIONS.private_view },
  { value: 'private_edit', label: GALLERY_PUBLICITY_LABELS.private_edit, description: GALLERY_PUBLICITY_DESCRIPTIONS.private_edit },
  { value: 'private_access', label: GALLERY_PUBLICITY_LABELS.private_access, description: GALLERY_PUBLICITY_DESCRIPTIONS.private_access },
];

export const GALLERY_PUBLICITY_FILTER_OPTIONS = [
  { value: 'public', label: GALLERY_PUBLICITY_LABELS.public },
  { value: 'private_view', label: GALLERY_PUBLICITY_LABELS.private_view },
  { value: 'private_edit', label: GALLERY_PUBLICITY_LABELS.private_edit },
  { value: 'private_access', label: GALLERY_PUBLICITY_LABELS.private_access },
];

export const getGalleryPublicityLabel = (publicity) =>
  GALLERY_PUBLICITY_LABELS[String(publicity ?? '').trim().toLowerCase()]
  || publicity
  || '—';
